//FYRE MEGA NAV

var init_lists_array = [];
    
function navControls() {

    const main_mega_ul = document.querySelector('.nav-bar__linklist');
    const all_megas = document.querySelectorAll('.mega-menu');
    
    //LOOP NAVS
    all_megas.forEach((single_mega) => {

        //VARS
        var mega_is_hidden = true,
            top_lvl_list = single_mega.querySelector('.mega-nav-top-lvl-list'),
            active_list = single_mega.querySelector('.active-nav-col'),
            featured_list = single_mega.querySelector('.active-nav-col-featured');
            if (!active_list) {
                return;
            }
        var current_active = active_list.dataset.activeList,
            init_list = current_active;

        //ADD INIT LISTS TO ARRAY
        init_lists_array.push(init_list);
            
        //GET TOP LVLS LIST AND LOOP MOUSEOVER
        var top_lvl_list_items = top_lvl_list.querySelectorAll('.mega-menu .nav-header-link');

        hoverTopLvl(top_lvl_list, top_lvl_list_items, active_list);

    });

    watchNavMutations(main_mega_ul);

}


function watchNavMutations(main_mega_ul) {
    //OBSERVER IF MENU IS HIDDEN
    var menu_observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if(!main_mega_ul.classList.contains('nav-dropdown--glued')) {
                    closedMega();
                }
            }   
        });
    });

    menu_observer.observe(main_mega_ul, {
        attributes: true //configure it to listen to attribute changes
    }); 
    
}

//WEN TOP LEVEL ITEM IS HOVER
function hoverTopLvl(top_lvl_list, top_lvl_list_items, active_list) {
    top_lvl_list_items.forEach((single_top_lvl_item) => {
        single_top_lvl_item.addEventListener("mouseover", (e) => {
            e.preventDefault;
            //GET AND SET NEW ACTIVE VAR
            var new_current_active = single_top_lvl_item.dataset.navGroupIndex;

            top_lvl_list.dataset.activeList = new_current_active;
            active_list.dataset.activeList = new_current_active;
            
            top_lvl_list_items.forEach((single_top_lvl_item_inner) => {
                if(single_top_lvl_item_inner.classList.contains('active-nav')) {
                    single_top_lvl_item_inner.classList.remove('active-nav');
                }
            });
            
            single_top_lvl_item.classList.add('active-nav');

            if(active_list.querySelector('.mega-menu__linklist.active-mega-list') != null) {
                active_list.querySelector('.mega-menu__linklist.active-mega-list').classList.remove('active-mega-list');
            }
                
            if(active_list.querySelector('#'+new_current_active) != null) {
                active_list.querySelector('#'+new_current_active).classList.add('active-mega-list');
            }
    
        });
    });
}

function closedMega() {

    //ADD REMOVE ACTIVE CLASS
    var all_top_lvl_active = document.querySelectorAll('.mega-nav-top-lvl-list .mega-menu__title');
    all_top_lvl_active.forEach((single_all_top_lvl_active) => {
        if(single_all_top_lvl_active.dataset.initHeader == 'true') {
            single_all_top_lvl_active.classList.add('active-nav');
        } else {
            single_all_top_lvl_active.classList.remove('active-nav');
        }
    });

    //REMOVE ALL ACTIVE FROM LISTS
    var all_active = document.querySelectorAll('.mega-menu__linklist.active-mega-list');
    all_active.forEach((single_all_active) => {
        single_all_active.classList.remove('active-mega-list');
    });

    //SET INIT LISTS ACTIVE
    init_lists_array.forEach((single_init_list) => {
        document.querySelector('#'+single_init_list).classList.add('active-mega-list');
    });

}